<template>
  <div class="bodywarp">
    <el-card class="box-card boxcard" style="min-height:calc(100% - 30px)">
      <!-- <div slot="header" class="clearfix"><b>报价列表</b></div> -->
      <el-form :inline="true" :model="formInline" class="demo-form-inline">
        <el-form-item label="合同生效日期">
          <el-date-picker v-model="formInline.dhtstarttime" type="date" placeholder="选择日期"></el-date-picker>
        </el-form-item>
        <el-form-item label="合同失效日期">
          <el-date-picker v-model="formInline.dhtendtime" type="date" placeholder="选择日期"></el-date-picker>
        </el-form-item>
        <el-form-item>
          <!-- <el-button type="primary" @click="GitHtsigningList()" size="medium">查询</el-button> -->
          <Debounce :time='300' :isDebounce="1">
            <el-button type="primary" @click.native="GitHtsigningList()" size="medium">查询</el-button>
          </Debounce>
        </el-form-item>
      </el-form>

      <el-table :data="tableData" border style="width: 100%" max-height="560" highlight-current-row :header-cell-style="{ background: '#eef1f6', textAlign: 'center' }" :cell-style="{ textAlign: 'center' }">
        <el-table-column type="index" label="序号" width="50"></el-table-column>
        <el-table-column prop="chtcode" label="合同号" width="160"></el-table-column>
        <!-- <el-table-column prop="cvencheck" label="确认状态" width="120"></el-table-column> -->
        <el-table-column prop="cvencheck" label="确认状态" width="110">
          <template slot-scope="scope">
            <span v-if="scope.row.cvencheck">
              <el-tag type="success" size="small" v-if="scope.row.cvencheck=='已确认'">{{scope.row.cvencheck}}</el-tag>
              <el-tag type="danger" size="small" v-else effect="dark">{{scope.row.cvencheck}}</el-tag>
            </span>

          </template>
        </el-table-column>
        <el-table-column prop="dhtstarttime" label="合同生效日期" width="130"></el-table-column>
        <el-table-column prop="dhtendtime" label="合同失效日期" width="130"></el-table-column>
        <!-- <el-table-column prop="cinvtype" label="物料类别" width="110"></el-table-column> -->
        <!-- <el-table-column prop="coacode" label="OA单号" width="100"></el-table-column> -->
        <!-- <el-table-column prop="dpushtime" label="推送日期" min-width="120"></el-table-column> -->
        <el-table-column prop="dloadendtime" label="要求确认时间" width="130"></el-table-column>
        <el-table-column prop="dvencheckdate" label="实际确认时间" width="180"></el-table-column>
        <!-- <el-table-column prop="darchivetime" label="归档日期" width="110"></el-table-column> -->
        <!-- <el-table-column prop="ddate" label="单据日期" width="140"></el-table-column> -->
        <el-table-column prop="cremark" label="备注"></el-table-column>
        <el-table-column label="操作" width="120" fixed="right">
          <template slot-scope="scope">
            <el-button size="mini" type="primary" plain @click="supedit(scope.row)">查看</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="pull-right" style="padding:20px;">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :page-sizes="[10,20, 50, 100, 1000]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="totalCount">
        </el-pagination>
      </div>
    </el-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      tableData: [],
      formInline: {
        dhtstarttime: "",
        dhtendtime: "",
      },
      // 分页
      pageSize: 20,
      pageIndex: 1,
      // 页数
      totalCount: 0,
      informdatanew: {},
    };
  },
  created() {
    if (this.$route.query.informdata) {
      if (this.$route.query.informdata.dhtstarttime != undefined) {
        this.formInline = {};
        this.formInline = this.$route.query.informdata;
      }
    }
    this.GitHtsigningList();
  },
  methods: {
    // 获取信息
    GitHtsigningList() {
      this.informdatanew = JSON.parse(JSON.stringify(this.formInline));
      this.$axios({
        method: "post",
        url: "CommonModule/Op_Supplier/GitHtsigningList",
        data: {
          dhtstarttime: this.formInline.dhtstarttime,
          dhtendtime: this.formInline.dhtendtime,
          pageSize: this.pageSize,
          pageIndex: this.pageIndex,
        },
      }).then((res) => {
        console.log(res, "获取信息结果");
        this.loading = false;
        if (res.data.Success) {
          // this.tableData = res.data.Data;
          this.tableData = res.data.Data.rows;
          this.totalCount = res.data.Data.totalCount;
        } else {
          this.$message.error(res.data.Message);
        }
      });
    },
    // 分页
    handleSizeChange(val) {
      this.pageSize = val;
      this.GitHtsigningList();
    },
    // 分页
    handleCurrentChange(val) {
      this.pageIndex = val;
      this.GitHtsigningList();
    },
    // 确认
    supedit(row) {
      this.$router.push({
        name: "OnlineContract",
        params: { rows: row, informdata: this.informdatanew },
      });
    },
  },
};
</script>
<style scoped>
.inputwidth {
  width: 30%;
}
.inputwidth .el-input__inner {
  border: 0;
}
</style>
